/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLineDashed = createReactComponent("line-dashed", "IconLineDashed", [
  ["path", { d: "M5 12h2", key: "svg-0" }],
  ["path", { d: "M17 12h2", key: "svg-1" }],
  ["path", { d: "M11 12h2", key: "svg-2" }]
]);

export { IconLineDashed as default };
//# sourceMappingURL=IconLineDashed.js.map
